module.exports = __webpack_public_path__ + "static/OliveStonePowder-ff9665f0b599e0512c804127af172945.webp";